var _defs, _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _circle, _circle2, _g2, _path10, _path11, _path12, _path13, _path14, _line, _path15, _path16, _path17, _g3, _path18, _path19, _path20, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImages3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 393.106,
    height: 369.009,
    viewBox: "0 0 393.106 369.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a875c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d2d59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#875995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d2d59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.961,
    y1: 0.938,
    x2: 0.016,
    y2: 0.027,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4d2d59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a875c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1.007,
    y1: 0.43,
    x2: 0.078,
    y2: 0.531,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#404041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.431,
    y1: 0.516,
    x2: 1.376,
    y2: 0.516,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.494,
    y1: 0.516,
    x2: 1.399,
    y2: 0.516,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbbdbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174,
    stopColor: "#b4b6b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    stopColor: "#a1a3a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#838486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#606162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.728,
    y1: 0.514,
    x2: 1.677,
    y2: 0.514,
    xlinkHref: "#linear-gradient-6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(-1085.152 -4335.464)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M1462.813,4335.464v320.37l-39.2-5.58-122.09-17.38L1133.813,4609l-.43-122.86a77.463,77.463,0,0,0,80.07-124Z",
    fill: "#ffeec0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M1365.621,4506.71l-.76,40.354s35.294-24,45.883-16.706c-9.177-21.177-12.837-43.722-15.661-55.957C1388.024,4482.636,1371.268,4506.945,1365.621,4506.71Z",
    fill: "#fa997b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M1365.433,4516.687s24.932-12.933,31.967-31.5c-13.17,10.372-31.779,23.554-31.779,23.554Z",
    fill: "#ef5d23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M1423.843,4646.694c-.11,1.18-.18,2.36-.23,3.56l-108.644-11.313c5.46-18.77,5.982-40.465,18.282-66.641,6.079-12.939,16.008-38.383,27.42-41.271,6.973-1.765,8.731,6.045,20.012,4.8,11.576-1.282,24.274-21.8,29.744-18.847C1436.187,4530.9,1429.223,4588.024,1423.843,4646.694Z",
    fill: "url(#linear-gradient)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M1347.96,4399.453s-9.49,20.529-16.462,23.627-18.4,14.913-16.268,35.442,13.933,50.01,37.084,52.21c23.24,2.209,41.4-16.973,54.569-39.438,10.458-19.754-4.309-44.728-17.284-49.182C1378.509,4418.305,1350.284,4410.3,1347.96,4399.453Z",
    fill: "#fa997b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M1361.3,4483.564s-13.57,2.11-22.67-.16c0,0,2.85-3.44,4.4-4.89l.01-.01c.19-.17.35-.31.49-.42a2.526,2.526,0,0,1,3.44.73c.45.75,3.17,1.16,4.16-.59s3.74-.63,4.45.88a10.164,10.164,0,0,0,2.91,2.63C1359.913,4482.744,1361.3,4483.564,1361.3,4483.564Z",
    fill: "#d26665"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M1361.3,4483.564c-1.13.59-3.11,3.09-5.37,4.92a1.16,1.16,0,0,0-.13.1,4.525,4.525,0,0,1-.4.3,7.8,7.8,0,0,1-3.11,1.54c-3.62.68-8.98-.74-10.06-2.63a26.8,26.8,0,0,0-3.6-4.39,21.467,21.467,0,0,0,2.32.41C1347.253,4484.884,1356.2,4484.124,1361.3,4483.564Z",
    fill: "#d26665"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M1339.407,4483.58s1.638.183,3.658.384c2.211.219,4.88.457,6.356.494,2.824.071,8.647-.88,10.743-.878",
    fill: "none",
    stroke: "#bc5b5b",
    strokeMiterlimit: 10,
    strokeWidth: 0.733
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M1355.4,4488.884a7.8,7.8,0,0,1-3.11,1.54c-3.62.68-8.98-.74-10.06-2.63a26.8,26.8,0,0,0-3.6-4.39,13.7,13.7,0,0,1,3.24,2.92c.8,1.29,3.15,2.94,6.39,3.5A10.967,10.967,0,0,0,1355.4,4488.884Z",
    fill: "#bc5b5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M1360.018,4482.765a14.569,14.569,0,0,1-4.615-3.552,2.541,2.541,0,0,0-2.32-1.335c-.621-.016-2.093,1.256-2.813,1.686a4,4,0,0,1-3.12-.16,6.522,6.522,0,0,0-2.077-1.39,2.725,2.725,0,0,0-2.03.49c.19-.17.35-.31.49-.42a2.526,2.526,0,0,1,3.44.73c.45.75,3.17,1.16,4.16-.59s3.74-.63,4.45.88C1355.923,4479.814,1360.028,4482.765,1360.018,4482.765Z",
    fill: "#bc5b5b"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M1326.927,4432.883s5.823-6.916,11.743,0",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.918
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M1476.413,4660.474a73.293,73.293,0,0,1-7.336,24.209c-.01.03-31.89,17.226-38.51,15.916-2.37-.46-4.9,2.255-6.674-4.4-.62-2.31-1.21-4.85-1.78-7.58-.42-2.04-.83-4.19-1.21-6.43-.88-5.15-1.63-10.76-2.18-16.58-1.21-12.89-1.42-26.83.2-39.23.09-.68.19-1.36.3-2.03.2-1.3.43-2.58.69-3.83.75-3.65,1.69-7.11,2.58-10.39,7.53-27.66-35.1-75.07-19.96-89.59a17.885,17.885,0,0,1,3.91-2.92c4.45-2.38,8.95-1.53,14.86,1.67,5.2,2.81,11.49,7.45,19.78,13.29,25.88,18.26,27.24,26.25,33.57,43.37C1479.7,4589.624,1478.613,4627.694,1476.413,4660.474Z",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M1434.963,4579.924c-8.12-7.16-10.94,7.49-4.94,15.96s-9.18,32.64-9.18,32.64l-1.62-4.17c.2-1.3.43-2.58.69-3.83.75-3.65,1.69-7.11,2.58-10.39,7.53-27.66-35.1-75.07-19.96-89.59a17.885,17.885,0,0,1,3.91-2.92c4.45-2.38,8.95-1.53,14.86,1.67,0,0-19.64,2.82-13.4,15.18s18.42,19.58,28.3,28.41S1443.083,4587.074,1434.963,4579.924Z",
    opacity: 0.5,
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M1265.27,4544.049l-22.289,17.831s-1.935-.838-4.591-2.251c-5.936-3.162-15.469-9.178-14.89-15.02.844-8.448-.927-12.929,1.646-18.556,1.93-4.248-.443-6.012-3.986-9.352-3.079-2.907-13.675-9.243-13.482-14.568a3.858,3.858,0,0,1,.877-2.331c3.1-3.948,13.326,3.308,20.851,11.417s17.262,11.809,19.462,12.268,8.644,4.017,12.5,8.145A15.377,15.377,0,0,1,1265.27,4544.049Z",
    fill: "#fa997b"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M1243.6,4562.687c-13.5-7.588-20.675-12.236-20.1-18.078.844-8.448-.927-12.929,1.646-18.556,1.93-4.248-.443-6.012-3.986-9.352-3.079-2.907-13.675-9.243-13.482-14.568,1.057,4.867,11.344,11.349,15.155,14.122,4.151,3.02,5.716,6.773,4.257,10.392s-1.841,10.451-1.07,16.362,16.047,15.766,16.047,15.766C1242.2,4559.309,1243.571,4562.239,1243.6,4562.687Z",
    opacity: 0.06
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 64.473,
    cy: 64.473,
    r: 64.473,
    transform: "translate(1091.625 4348.147)",
    fill: "#ffeec0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 64.473,
    cy: 64.473,
    r: 64.473,
    transform: "translate(1086.627 4346.482)",
    fill: "none",
    stroke: "#d3bd85",
    strokeMiterlimit: 10,
    strokeWidth: 2.95
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M1339.709,4449.313s1.023-7.607-3.833-10.266-11.188-1.15-9.481,3.573Z",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M1339.449,4450.242c-.935,2.807-10.405,2.9-12.808-2.573s2.484-10.2,7.014-8.818A8.78,8.78,0,0,1,1339.449,4450.242Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M1334.626,4445.979a6.148,6.148,0,0,0,.111-.685,4.1,4.1,0,0,0-.272-2.723,4.448,4.448,0,0,0-.65-1.115c-1.371-1.686-3.4-1.529-5.109-.523a3.843,3.843,0,0,0-1.776,2.836,4.408,4.408,0,0,0-.248,1.363,3.7,3.7,0,0,0,3.334,3.917A4.308,4.308,0,0,0,1334.626,4445.979Z",
    fill: "#1a1a1a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M1363.126,4449.313s-1.023-7.607,3.833-10.266,11.188-1.15,9.481,3.573Z",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M1363.386,4450.242c.935,2.807,10.405,2.9,12.808-2.573s-2.484-10.2-7.014-8.818A8.78,8.78,0,0,0,1363.386,4450.242Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M1371.6,4447.272a6.211,6.211,0,0,0,.209-.662,4.086,4.086,0,0,0,.129-2.734,4.465,4.465,0,0,0-.48-1.2c-1.109-1.868-3.145-2.009-4.977-1.264a3.848,3.848,0,0,0-2.172,2.547,4.431,4.431,0,0,0-.445,1.312,3.7,3.7,0,0,0,2.726,4.362A4.31,4.31,0,0,0,1371.6,4447.272Z",
    fill: "#1a1a1a"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M1329.2,4442.989a.824.824,0,1,1-1.648,0,1.09,1.09,0,0,1,.894-1.033C1328.9,4441.956,1329.2,4442.535,1329.2,4442.989Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M1366.548,4443.918a.823.823,0,0,1-1.647,0,1.089,1.089,0,0,1,.894-1.033C1366.25,4442.885,1366.548,4443.463,1366.548,4443.918Z",
    fill: "#fff"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M1363.3,4432.782s5.823-6.916,11.743,0",
    fill: "none",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.918
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M1346.609,4452.128s.594,4.506-.313,6.109-3.675,2.9-2.557,6.23c1.315,3.915,5.025,2.239,5.025,2.239",
    fill: "none",
    stroke: "#d26665",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M1471.486,4679.663c-3.671,11.68-16.161,19.336-31.14,22.559-.486.1-.973.2-1.459.295-.572.125-1.154.229-1.745.334h-.019c-11.823,2.088-23.541,2.05-30.244.515-22.368-5.11-76.219-44.279-97.891-57.646s-41.142-31.75-45.328-48.217c-2.145-8.447-3.881-13.6-6.083-17.448q-.258-.445-.515-.858h-.009a22.446,22.446,0,0,0-1.745-2.46,39.428,39.428,0,0,0-6.083-5.845,45.316,45.316,0,0,1-6.589-6.121c-2.422-2.994-3.146-5.969-.21-9.01a46.893,46.893,0,0,1,4.167-3.032c.677-.382,1.354-.763,2.012-1.144,4.91-2.842,12.347-2.775,12.347-2.775a17.542,17.542,0,0,1,7.008.458c.62.171,1.24.372,1.869.61a32.7,32.7,0,0,1,10.316,6.789h.029l.01.009c.9.191,1.735.334,2.526.439,6.436.81,10.307-1.1,18.049-3.185,8.715-2.364,25.524-5.911,45.928,18.641,20.385,24.522,29.3,33.761,38.7,35.6,3.986.791,18.068,6.569,33.734,15.331,1.392.773,2.8,1.573,4.214,2.394,19.165,11.2,39.55,26.506,46.138,42.39.095.21.334.887.62,1.812l.029.086C1470.942,4672.855,1472.153,4677.546,1471.486,4679.663Z",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M1471.486,4679.663c-3.671,11.68-16.161,19.336-31.14,22.559-.486.1-.973.2-1.459.295-.572.125-1.154.229-1.745.334h-.019c-11.823,2.088-23.541,2.05-30.244.515-22.368-5.11-76.219-44.279-97.891-57.646s-41.142-31.75-45.328-48.217c-2.145-8.447-3.881-13.6-6.083-17.448,4.252-4.5,10.45-2.2,10.45-2.2s20.661,19.775,30.339,37.863c13.453,25.152,63.748,45.089,87.061,41.723,13.949-2.012,31.044-2.241,40.808,1.907,5.434,2.307,7.513,6.169,3.423,11.928-1.03,1.458-8.791,10.631-6.045,15.96,4.252,8.239,17.095,5.96,26.935,2,11.613-4.663,16.657-9.563,19.47-19.317.019.047.047.114.076.181l.029.086C1470.942,4672.855,1472.153,4677.546,1471.486,4679.663Z",
    opacity: 0.5,
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M1257.083,4579.192h-.009a24.842,24.842,0,0,0-1.745-2.456,39.039,39.039,0,0,0-6.085-5.844c-6.375-5.158-11.709-10.031-6.8-15.132.229-.244,1.719-1.478,1.914-1.609.661-.484,15.472-10.636,16.136-11.023,4.9-2.788,12.159,1.621,19.671,13.535.905.2-.493,3.011-.95,4.468C1277.495,4565.459,1272.43,4583.716,1257.083,4579.192Z",
    fill: "#4b355b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M1308.945,4552.375s18.81-4.122,38.268,20.829,26.767,31.857,38.172,34.966a111.463,111.463,0,0,1,22.283,9.286s-16.262-5.84-22.32-6.344-24.9-11.61-41.559-36.512C1336.385,4563.831,1314.561,4551.473,1308.945,4552.375Z",
    fill: "#1b2544",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M1350.043,4539.865s8.055-12.534,15.122-8.926,13.83,6.694,23.064,1.81c-7.734,8.251-17.879,4.18-22.028,1.427C1361.264,4530.9,1354.121,4536.2,1350.043,4539.865Z",
    fill: "#1b2544",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M1422.793,4596.134s-2.4-13.779-11.348-31.81c-3.779-8.3-7.995-18.166-7.995-18.166s2.751,11.959,6.192,19.195,9.89,19.941,13.151,31.147",
    fill: "#1b2544",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M1451.361,4645.875s13.134,11.483,20.2,33.657C1473.251,4665.592,1458.242,4648.024,1451.361,4645.875Z",
    fill: "#1b2544",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M1352.955,4447.011s-5.153-5.03-10.182,0",
    fill: "none",
    stroke: "#f1f1f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 18.959,
    transform: "translate(1392.661 4447.246)",
    fill: "rgba(255,255,255,0.2)",
    stroke: "#f1f1f2",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M1397.4,4379.9c9.915-14.053,28.314-14.5,39.02-7.2,12.192,8.307,26.393,12.235,29.253,24.706,3.209,13.99.646,37.4-17.841,53.544-21.412,18.691-38.779,4.474-38.779,4.474Z",
    fill: "url(#linear-gradient-6)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M1405.821,4448.572s2.939,1.9,4.187-2.738,7.937-7.226,11.294-3.765c3.7,3.816.021,20.346-8.975,20.544s-5.385-5.164-5.385-5.164Z",
    fill: "#fa997b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M1412.914,4449.532c-1.352,2.178-1.433,4.581-.174,5.364s3.38-.347,4.74-2.531c1.344-2.181,1.421-4.585.166-5.364S1414.266,4447.347,1412.914,4449.532Z",
    fill: "#ef5d23"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 19.853,
    cy: 19.853,
    r: 19.853,
    transform: "translate(1302.812 4426.517)",
    fill: "rgba(255,255,255,0.2)",
    stroke: "#f1f1f2",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M1392.657,4446.366a19.817,19.817,0,0,1-19.85,19.861c-.65,0-1.3-.031-1.94-.091a.059.059,0,0,1-.04-.01,19.507,19.507,0,0,1-4.41-.95,20.021,20.021,0,0,1-2.73-1.179,19.849,19.849,0,0,1,9.12-37.48,19.531,19.531,0,0,1,7.51,1.48,19.763,19.763,0,0,1,7.67,5.579,20.184,20.184,0,0,1,2.2,3.2,19.57,19.57,0,0,1,2.05,5.529,18.589,18.589,0,0,1,.41,3.75C1392.657,4446.156,1392.657,4446.267,1392.657,4446.366Z",
    fill: "rgba(255,255,255,0.2)",
    stroke: "#f1f1f2",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M1387.773,4434.035l-21.08,30.68a20.086,20.086,0,0,1-2.73-1.18,19.762,19.762,0,0,1-5.26-3.94l21.4-31.14A19.764,19.764,0,0,1,1387.773,4434.035Z",
    opacity: 0.3,
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M1391.743,4442.511l-14.84,22.775a20.489,20.489,0,0,1-3.948.453c-.65,0-1.97-.09-1.98-.1l18.718-28.658a19.553,19.553,0,0,1,2.05,5.53Z",
    opacity: 0.3,
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M1336.865,4433.523l-21.236,30.87a14.723,14.723,0,0,1-2.7-1.29,22.041,22.041,0,0,1-5-4.21l21.269-30.95A19.765,19.765,0,0,1,1336.865,4433.523Z",
    opacity: 0.3,
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M1341.152,4441.422l-15.615,24.059a17.1,17.1,0,0,1-3.7.191c-.5,0-2.007-.2-2.017-.206l19.287-29.233a19.279,19.279,0,0,1,.94,1.94A16.006,16.006,0,0,1,1341.152,4441.422Z",
    opacity: 0.3,
    fill: "url(#linear-gradient-7)"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M1371.4,4390.243c-4.7,9.777-22.591,31.7-35.013,33.306s-16.947,14.213-19.4,21.093-12.678,10.5-12.678,10.5c2.942-8.371,4.014-13.529-.3-25.128-3.5-9.392-7.053-23.99,6.117-38.943s21.423-26.828,42.418-26.463a23.126,23.126,0,0,1,11.193,2.859C1372.48,4372.46,1374.917,4382.96,1371.4,4390.243Z",
    fill: "url(#linear-gradient-11)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M1363.738,4367.467s-16.373-.3-27.746,5.166c-5,2.4-9.615,6.517-13.9,11.436s-10.779,16.339-12.594,20.5-3.869,13.98-.073,21.565,4.823,20.891-5.111,29.01c2.942-8.371,4.014-13.529-.3-25.128-3.5-9.392-7.053-23.99,6.117-38.943s21.423-26.828,42.418-26.463A23.126,23.126,0,0,1,1363.738,4367.467Z",
    fill: "url(#linear-gradient-12)",
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M1345.021,4395.037c4.907,9.674,14.7,23.823,39.531,27.529,12.4,1.85,18.269,15.8,20.871,22.63s12.9,10.226,12.9,10.226c-3.121-8.307-4.3-13.44-.238-25.129,3.3-9.465,6.086-23.733-6.95-38.8-11.651-13.468-19.752-27.952-40.734-27.137a23.118,23.118,0,0,0-11.129,3.1C1350.639,4372.631,1341.353,4387.831,1345.021,4395.037Z",
    fill: "url(#linear-gradient-13)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M1183.968,4402.17a13.731,13.731,0,0,0-6.388,1.569,12.971,12.971,0,0,0-16.662-5.7,18.9,18.9,0,0,0-36.575,2.517,15.014,15.014,0,1,0-4.893,29.208h64.518a13.8,13.8,0,1,0,0-27.593Z",
    fill: "none",
    stroke: "#404041",
    strokeMiterlimit: 10,
    strokeWidth: 2.26
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 4.765,
    cy: 4.765,
    r: 4.765,
    transform: "translate(1127.95 4407.856)",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 4.765,
    cy: 4.765,
    r: 4.765,
    transform: "translate(1143.362 4407.856)",
    fill: "#404041"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 4.765,
    cy: 4.765,
    r: 4.765,
    transform: "translate(1158.775 4407.856)",
    fill: "#404041"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImages3);
export default __webpack_public_path__ + "static/media/images3.a526fccc45e12c2726a5a8bac970fe39.svg";
export { ForwardRef as ReactComponent };